module.exports = __webpack_public_path__ + "png/sound.png?9b28603c3922146279b80a9e76f19736";